// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: { app: path(ROOTS_DASHBOARD, '') },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/user-id/edit`)
  },
  question: { root: path(ROOTS_DASHBOARD, '/question') },
  truth: { root: path(ROOTS_DASHBOARD, '/truth') },
  idea: {
    root: path(ROOTS_DASHBOARD, '/idea'),
    list: path(ROOTS_DASHBOARD, '/idea/list'),
    newIdea: path(ROOTS_DASHBOARD, '/idea/new'),
    editById: path(ROOTS_DASHBOARD, `/idea/idea-id/edit`)
  },
  options: {
    root: path(ROOTS_DASHBOARD, '/options'),
    group: path(ROOTS_DASHBOARD, '/options/group'),
    value: path(ROOTS_DASHBOARD, '/options/value')
  },
  sub_group: { root: path(ROOTS_DASHBOARD, '/sub-group') },
  avatar: { root: path(ROOTS_DASHBOARD, '/avatar') },
  emoji: { root: path(ROOTS_DASHBOARD, '/emoji') },
  media: { root: path(ROOTS_DASHBOARD, '/media') },
  level: { root: path(ROOTS_DASHBOARD, '/level') },
  wallet_token: { root: path(ROOTS_DASHBOARD, '/wallet-token') },
  lets_go_out: { root: path(ROOTS_DASHBOARD, '/lets-go-out') },
  location: {
    root: path(ROOTS_DASHBOARD, '/location'),
    country: path(ROOTS_DASHBOARD, '/location/country'),
    state: path(ROOTS_DASHBOARD, '/location/state'),
    city: path(ROOTS_DASHBOARD, '/location/city'),
  },
  settings: {
    root: path(ROOTS_DASHBOARD, '/settings'),
    account: path(ROOTS_DASHBOARD, '/settings/account')
  },
};